"use client";

import React from "react";
import { Calendar, Globe, Package, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  icon: Calendar,
  value: "125%",
  label: "Average ROI"
}, {
  icon: Package,
  value: "24/7",
  label: "Active Support"
}, {
  icon: ShieldCheck,
  value: "100%",
  label: "Client Success"
}];
export default function GrowthMetrics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}